export default "__VITE_ASSET__BW6rI2Mf__"